export default __webpack_public_path__ + "static/media/iconLoja.7b3f595e.svg";